<ng-container class="survey-page__header">
  <img
    class="lib-survey-page-header__icon"
    src="/surveys-assets/images/header.svg"
  />
  <h2 class="lib-survey-page-header__title">{{ title }}</h2>
</ng-container>
